import React, {Component, useRef} from 'react';
import {connect} from 'react-redux';
import Field from './Field';
import {Modal} from 'react-bootstrap';
import './Voting.css';
import {dynamicRender, intervalDataChanged, proceedWithoutSavingInterval, renderShare, renderShareProcess, showIntervalChangeWarning, submitVote} from "../../actions/CompetitionActions";
import $ from 'jquery';

import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import {faFacebookF, faTwitter} from '@fortawesome/fontawesome-free-brands/index'
import {faSpinner} from '@fortawesome/fontawesome-free-solid/index'
import VideoSelector from "./VideoSelector";
import TippingSelector from "./TippingSelector";
import { Trans,withTranslation} from 'react-i18next';
import {
    EmailIcon,
    FacebookIcon,
    FacebookMessengerIcon,
    PinterestIcon,
    LinkedinIcon,
    PocketIcon,
    RedditIcon,
    TumblrIcon,
    TwitterIcon,
    WhatsappIcon,
    EmailShareButton,
    FacebookShareButton,
    FacebookMessengerShareButton,
    PinterestShareButton,
    PocketShareButton,
    RedditShareButton,
    TumblrShareButton,
    TwitterShareButton,
    WhatsappShareButton,
    LinkedinShareButton
    } from "react-share";
    import { FaSms, FaBuffer, FaWordpress, FaFlipboard,FaSkype, FaTheaterMasks} from "react-icons/fa";
    import { IoMdArrowDropleft,IoMdArrowDropright} from 'react-icons/io';
    import CustomShare from '../components/custom-share';
    import { FACEBOOK_APP_ID } from '../../util/Constants';
import { getTippingUserSelections } from '../../util/helpers/Helpers';
import { allowScoreMargin } from '../../actions/AuthActions';



class Voting extends Component {

    constructor(props) {

        super(props);

        this.socialShareRef1 = React.createRef();
        this.socialShareRef2 = React.createRef();
        this.submitBtnRef = React.createRef();
        this.state = {
            selectedPlace: null,
            willingToPlay: false,
            intervalDataChanged: false,
            showIntervalChangeWarning: false
        }

        this.handleSubmit = this.handleSubmit.bind(this);
        this.changeSelection = this.changeSelection.bind(this);
        this.handleSelectPlayer = this.handleSelectPlayer.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleChangeShare =  this.handleChangeShare.bind(this);

        this.shapesList = {
          1: 'dyn-round',
          2: 'no-border-radius',
          3: 'no-border-radius dyn-skew',
          4: 'dyn-circle',
          5: 'no-border-radius dyn-shield',
        };
        this.defaultShape = 1;
        this.classRadius = '';
    }

    changeSelection = (selections) => {
        this.setState({selections});

        const {competition,t} = this.props;
        const {currentRound} = competition;

        if (!this.props.showOnlyLeaderboard && this.state.loggedIn && currentRound && currentRound.voteOpen) {
            this.props.dispatch(
                intervalDataChanged(
                    true,
                    this.props.dispatch
                )
            );
        }
    }

    changeSelectionLoad = (selections) => {
        this.setState({selections});
    }

    proceedWithoutSavingInterval = () => {
        let idRound = 0;
        if (this.props && this.props.competition && this.props.competition.intervalChangeDetect
            && this.props.competition.intervalChangeDetect.showIntervalChangeWarning) {
            idRound = this.props.competition.intervalChangeDetect.showIntervalChangeWarning;
        }
        if (idRound != null) {
            this.props.dispatch(
                proceedWithoutSavingInterval(
                    idRound,
                    this.props.dispatch
                )
            );
        }
        this.props.dispatch(
            intervalDataChanged(
                false,
                this.props.dispatch
            )
        );
        this.closeIntervalChangeModal();
    }

    closeIntervalChangeModal = () => {

        this.props.dispatch(
            showIntervalChangeWarning(
                false,
                this.props.dispatch
            )
        );
        this.setState({
            ...this.state,
            showIntervalChangeWarning: false
        });
    }

    proceedSavingInterval = () => {
        this.closeIntervalChangeModal();
        $('html, body').animate({
            scrollTop: $("#vote-submit-btn").offset().top
        }, 500);
        if (this.submitBtnRef) {
            // doesnt support safari
            // this.submitBtnRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
            this.submitBtnRef.current.click();
        }
    }

    intervalModalAwayClick = () => {
        this.closeIntervalChangeModal();
    }

    handleSubmit = (idInterval) => {

        const {t} = this.props;
        const {selections} = this.state;
        const {comp} = this.props;
        const {field: generalField, type} = this.props.comp;
        const {currentRound} = this.props.competition;
        const isSpecial = allowScoreMargin(this.props.comp);
        let localContext = `${comp.id}-`;

        const field = (currentRound && currentRound.override && currentRound.field) || generalField;

        let selectionValid = false;
        let cleanSelection = undefined;

        if (type === "leaderboard") {

            const nPositions = field.lines.reduce((acc, l) => {
                return acc + l.positions.length;
            }, 0);

            console.log("nPositions", nPositions);

            selectionValid = selections && selections[idInterval] && nPositions === selections[idInterval].length;
            this.setState({
                ...this.state,
                submitError: !selectionValid,
                submitFor: idInterval,
                submitErrorMessage: !selectionValid ? t('select_all_vote') : ''
            });

            if (selectionValid) {
                cleanSelection = selections[idInterval].map(s => ({
                    idPosition: s.position.id,
                    idPlayer: s.player.id,
                }));
            }

        } else if (type === "video-lb") {

            selectionValid = selections && selections.length > 0;

            this.setState({
                ...this.state,
                submitError: !selectionValid,
                submitFor: idInterval,
                submitErrorMessage: !selectionValid ? t('select_a_video') : ''
            });
            const {competition} = this.props;
            let positionID = null;
            if (competition.data.field) {
                if (competition.data.field.lines) {
                    if (competition.data.field.lines[0]) {
                        if (competition.data.field.lines[0].positions) {
                            if (competition.data.field.lines[0].positions) {
                                const positionArr = competition.data.field.lines[0].positions;
                                const defPosObj = positionArr.find(obj => obj.name === 'default-position');
                                if (defPosObj) {
                                    positionID = defPosObj.id;
                                }
                            }
                        }
                    }
                }
            }
            if (selections && selections[idInterval]) {
                cleanSelection = selections[idInterval].map((s, idx) => ({
                    idPosition: positionID,
                    idPlayer: s.idVideo,
                }));
            }
        } else if (type === "tipping") {

            if (selections) {
                console.log("idInterval", idInterval)
                cleanSelection = selections[idInterval].map((s) => ({
                    idTeam: s.selection.id,
                    idTippingGame: s.tippingGameId,
                    scoreMargin: !isSpecial || s.selection.id === 1 ? null : s.scoreMargin
                }));
                selectionValid = currentRound.tippingGames.filter(tg => tg.enabled).length === cleanSelection.length;

                // score margin no selected
                const noMargin = cleanSelection.find(obj => obj.idTeam !== 1 && (!obj.scoreMargin || obj.scoreMargin == 0));

                console.log('select margin', selections);
                console.log('clean margin', cleanSelection);
                console.log('no margin', noMargin);

                if (isSpecial && noMargin) {
                    selectionValid = false;
                }

                if (selectionValid) {
                    let tippingUserSelections = (comp && comp.id) ? getTippingUserSelections(comp.id) : [];
                    if (tippingUserSelections) {
                        tippingUserSelections = tippingUserSelections.filter(tus => tus.idInterval !== currentRound.id);
                    } else {
                        tippingUserSelections = [];
                    }
                    cleanSelection.forEach(cs =>
                        tippingUserSelections.push({
                            idInterval: currentRound.id,
                            idTeam: cs.idTeam,
                            idTippingGame: cs.idTippingGame,
                            scoreMargin: cs.scoreMargin
                        }))
                    localStorage.setItem(localContext + 'tippingUserSelections', JSON.stringify(tippingUserSelections));
                }

                console.log("selectionValid", selectionValid);
            } else {
                selectionValid = false;
            }
            if (!selectionValid) {
                this.setState({
                    ...this.state,
                    submitError: !selectionValid,
                    submitFor: idInterval,
                    submitErrorMessage: !selectionValid ? t('select_game') : ''
                });
            }
            else {
                this.setState({
                    submitError: false,
                });
            }
            console.log("cleanSelection", cleanSelection);
        }
        if (selectionValid) {
            const data = {
                idInterval,
            };
            if (type !== "tipping") {
                data.votes = cleanSelection;
            } else {
                data.votesTipping = cleanSelection;
            }

            localStorage.removeItem(localContext + 'dynamicRenderUrl');

            this.props.dispatch(submitVote(
                data,
                localStorage.getItem(localContext + 'token'),
                this.props.dispatch
            ));
        }
    }

    handleSelectPlayer = (idPosition) => {

        if (!this.state.loggedIn) {
            this.setState({
                ...this.state,
                willingToPlay: true
            });
            return;
        }

        const currentRound = this.props.competition.currentRound;

        if (currentRound && !currentRound.voteOpen)
            return;

        $('html, body').animate({
            scrollTop: $(".chooser").offset().top
        }, 500);

        this.setState({
            ...this.state,
            selectedPlace: idPosition
        });
    }

    componentDidUpdate(prevProps) {
        const {competition} = this.props;
        const newState = {};
        newState.shares = [];
        if (!prevProps.competition.shareContentUrlBySocialNetworkId
            && competition.shareContentUrlBySocialNetworkId) {
            const roundId = competition.submittedIdInterval;
            let facebookShare = '';
            let twitterShare = '';
            competition.shareContentUrlBySocialNetworkId.forEach(share => {
                if (share && share.id) {
                    switch (share.id) {
                        case 1:
                            facebookShare = share.url;
                            break;
                        case 2:
                            twitterShare = share.url;
                            break;
                    }
                }
            });
            newState.shares.push({roundId, facebookShare, twitterShare});
            this.setState(newState);
        }

        // process dynamic image render
        const dynamicRenderUrl = (competition && competition.data && competition.data.id)
          ? localStorage.getItem(competition.data.id + '-' + 'dynamicRenderUrl') : null;
        const { currentRound } = this.props.competition;
        if (!prevProps.competition.dynamicRender.dynamicSubmitted
            && competition && competition.data && competition.data.dynamicRenderBackgroundImageUrl
            && (competition.data.type === "leaderboard" || competition.data.type === "video-lb")
            && competition.data.dynamicRenderBackgroundImageUrl !== ''
            && !competition.dynamicRender.dynamicSubmitting
            && !competition.dynamicRender.dynamicSubmitted
            && (!dynamicRenderUrl || dynamicRenderUrl == null)
            && this.props.auth.loggedIn && competition.submitted
            && competition.submittedIdInterval === currentRound.id) {

            const dynamicRenderInput = {
                'idCompetition': competition.data.id,
                'idVote': competition.submittedIdVote,
                'ipAddress': "0.0.0.0",
                'referrer': window.location.protocol + "//" + window.location.host
            }
            this.props.dispatch(dynamicRender(dynamicRenderInput, this.props.dispatch));
        }

        // if (shares) {
        //     shares.forEach(s => {
        //         newState.shares.push({
        //             roundId: s.idCompetition,
        //             facebookShare: s.facebookShare,
        //             twitterShare: s.twitterShare
        //         })
        //     });
        // }
    }

    componentWillReceiveProps(nextProps) {

        let newState = {
            ...this.state,
            loggedIn: nextProps.auth.loggedIn,
            user: nextProps.auth.user,
        };

        if (this.props.competition &&
            this.props.competition.currentRound &&
            this.props.competition.currentRound.id !== nextProps.competition.currentRound.id) {

            newState.selectedPlace = null;

        }
        if (nextProps.auth.loggedOffNow) {
            this.state.selections = undefined;
        }

        if (nextProps.competition && nextProps.competition.intervalChangeDetect
            && nextProps.competition.intervalChangeDetect.hasOwnProperty('showIntervalChangeWarning')
            && nextProps.competition.intervalChangeDetect.showIntervalChangeWarning
                !== this.props.competition.intervalChangeDetect.showIntervalChangeWarning) {
            newState.showIntervalChangeWarning = nextProps.competition.intervalChangeDetect.showIntervalChangeWarning;
        }

        // if (!this.props.auth.alreadyLoggedIn || this.state.lackingPlaces) {
        //
        // let rounds = nextProps.competition && nextProps.competition.rounds ? nextProps.competition.rounds : this.props.competition.rounds;
        //
        // newState.selections = rounds.map(r => {
        //     return {
        //         roundId: r.id,
        //         picks:
        //             [{
        //                 place: 1,
        //                 playerId: null
        //             }, {
        //                 place: 2,
        //                 playerId: null
        //             }, {
        //                 place: 3,
        //                 playerId: null
        //             }]
        //     }
        // });
        // newState.lackingPlaces = !(newState.selections && newState.selections.length);
        //
        // let votes = nextProps.auth.votes ? nextProps.auth.votes : this.props.auth.votes;
        // if (votes && votes.length) {
        //     let vvv = votes.reduce((acc, v) => {
        //         if (!acc.find(a => a.roundId === v.idCompetition)) {
        //             acc.push({
        //                 roundId: v.idCompetition,
        //                 picks: []
        //             });
        //         }
        //         acc.find(a => a.roundId === v.idCompetition).picks.push({
        //             place: v.points,
        //             playerId: v.idPlayer
        //         })
        //         return acc;
        //     }, []);
        //
        //     if (newState.selections) {
        //         // console.log("Votes are stored");
        //         let v2 = newState.selections.slice();
        //         vvv.forEach((v, idx) => v2[idx] = {...v});
        //         newState.selections = v2;
        //     }
        // }
        // }

        // let shares = nextProps.auth.shares ? nextProps.auth.shares : this.props.auth.shares;
        // newState.shares = [];
        // if ((!shares || !shares.length) && nextProps.competition.newRender) {
        //     let {roundId, facebookShareUrl, twitterShareUrl} = nextProps.competition.newRender;
        //     newState.shares.push({
        //         roundId,
        //         facebookShare: facebookShareUrl,
        //         twitterShare: twitterShareUrl
        //     });
        // }
        // if (shares) {
        //     shares.forEach(s => {
        //         newState.shares.push({
        //             roundId: s.idCompetition,
        //             facebookShare: s.facebookShare,
        //             twitterShare: s.twitterShare
        //         })
        //     });
        // }
        //
        // if (nextProps.competition.newRender) {
        //     let s = newState.shares.find(ss => ss.roundId === nextProps.competition.newRender.roundId);
        //     if (s) {
        //         s.twitterShare = nextProps.competition.newRender.twitterShareUrl;
        //         s.facebookShare = nextProps.competition.newRender.facebookShareUrl;
        //     }
        // }

        this.setState(newState);
    }

    isSocialNetworkEnabledForCompetition = (socialNetworkId) => {
        const {data, currentRound} = this.props.competition;
        if (!this.props.auth.loggedIn || !this.props.competition.submitted
            || this.props.competition.submittedIdInterval !== currentRound.id) {
                return false;
        }
        // if (!this.state.shares) {
        //     return false
        // }
        // const share = this.state.shares.find(s => s.roundId === currentRound.id);
        // if (!share) {
        //     return false;
        // }
        // if ((socialNetworkId === 1 && !share.facebookShare) ||
        //     (socialNetworkId === 2 && !share.twitterShare)) {
        //     return false;
        // }
        if (data && data.socialNetworksEnabled) {
            return !!data.socialNetworksEnabled.find(sn => sn.id === socialNetworkId);
        }
        if (data.socialNetworks) {
            return !!data.socialNetworks.find(sn => sn.id === socialNetworkId);
        }
        return false;
    };

    handleTwitterShare = () => {
        this.processShare(2);

        // const {competition} = this.props;
        // const {currentRound} = competition;
        // const {shares} = this.state;
        // if (!shares) {
        //     return;
        // }
        // const share = this.state.shares.find(s => s.roundId === currentRound.id);
        // if (!share) {
        //     return;
        // }

        // var shareText = competition.socialSharingTextDescription || '';
        // var twitterShareUrl = share.facebookShare;
        // window.open('http://www.twitter.com/intent/tweet?url=' +
        //     encodeURIComponent(twitterShareUrl) + '&text=' + encodeURIComponent(shareText),
        //     'twitter-share-dialog', 'width=626,height=436'
        // );
    };

    handleFacebookShare = () => {
        this.processShare(1);
    };

    processShare = (idSocialNetwork) => {
        const {competition, comp} = this.props;
        const {currentRound} = competition;

        if (!this.props.auth.loggedIn || !competition.submitted
            || competition.submittedIdInterval !== currentRound.id || !competition.submittedIdVote) {
                return false;
        }

        const {shares} = this.state;
        if (shares && shares.find(s => s.roundId === currentRound.id)) {
            var shareText = competition.socialSharingTextDescription || '';
            const share = shares.find(s => s.roundId === currentRound.id);
            renderShareProcess(share, shareText, idSocialNetwork);
        }
        else {
            const renderData = {
                idCompetition: comp.id,
                idVote: competition.submittedIdVote
            };
            this.props.dispatch(
                renderShare(renderData, this.props.dispatch, idSocialNetwork)
            );
            return;
        }
    };

    handleCloseModal = () => {
        this.setState({
            ...this.state,
            willingToPlay: false
        })
    }

    handleChangeShare = (state,socialShareRef) =>{
        const scrollRef = socialShareRef.current
        const currentPosition =scrollRef.scrollLeft;
        const position =  window.innerWidth > 650?50:73;
        let scrollPosition = state === 'previous'?Math.round(((currentPosition - position)/position)*position):Math.round(((currentPosition + position)/position)*position)
        scrollRef.scrollLeft = scrollPosition;
      }


    render() {

        const {submitError, submitFor, submitErrorMessage} = this.state;

        const {competition,t} = this.props;
        const {currentRound, data} = competition;

        console.log('voting-curr', currentRound);

        let voteContOnlyLeaderboard = null;

        let voteCont = (<div className='vote-cont'>
            <div className='loading-rounds'></div>
        </div>);

        // process dynamic image render
        let {dynamicSubmitting} = competition.dynamicRender ? competition.dynamicRender : competition;
        let localContext = (data && data.id) ? `${data.id}-` : null;
        let dynamicRenderUrl = localContext ? localStorage.getItem(localContext + 'dynamicRenderUrl') : null;

        let noBorderRadius = (competition && competition.defaultShape == 2);

        let submitButtonText = data && data.submitCopy && data.submitCopy != "" ? data.submitCopy : 'Submit vote';
        if (currentRound) {

            let shareVote = null;
            // let currentShare = this.state.shares && this.state.shares.find(s => s.roundId === currentRound.id);

            let inviteToVote = null;
            let dynamicRenderBlock = null;

            // if (currentRound.voteOpen) {
            //     // const voteText = currentShare ? 'Edit Vote' : 'Submit Vote';
            //     inviteToVote =
            //         this.state.loggedIn ? null :
            //             //     (<div className='vote-btn'
            //             //           style={{
            //             //               backgroundColor: '#00b909'/*data ? data.buttonColor : ''*/,
            //             //               color: data ? data.primaryColor : ''
            //             //           }}
            //             //           onClick={() => this.handleSubmit(currentRound.id)}>{`${voteText}`}</div>) :
            //             // (<div style={{color: data ? data.primaryColor : ''}}
            //             //       className='please-log-in'>Please register to enter</div>);
            // }

            // if (this.isSocialNetworkEnabledForCompetition(1) || this.isSocialNetworkEnabledForCompetition(2)) {
            //     shareVote = (<div className='share-btns-cont'>
            //         {this.isSocialNetworkEnabledForCompetition(2) ? (
            //             <div className='share share-twitter'>
            //                 <div className="tw"
            //                      onClick={this.handleTwitterShare}>
            //                     <FontAwesomeIcon icon={faTwitter}
            //                                      className={`submit-arr`}
            //                     />
            //                     <Trans i18nKey="tweet" />
            //                 </div>
            //             </div>
            //         ) : null}
            //         {this.isSocialNetworkEnabledForCompetition(1) ? (
            //             <div className='share share-facebook'>
            //                 <div className="fbk"
            //                      onClick={this.handleFacebookShare}>
            //                     <FontAwesomeIcon icon={faFacebookF}
            //                                      className={`submit-arr`}
            //                     />
            //                     <Trans i18nKey="share" />
            //                 </div>
            //             </div>
            //         ) : null}
            //         {competition.shareSubmittng ?
            //         (<div className="loading-block" style={{color: data ? data.primaryColor : ''}}><Trans i18nKey="loading" /></div>)
            //         : null}
            //     </div>);
            // }


            const socialShareTemplate = (socialShareRef)=>{
                const socialShareTitle = data.shareEnabled && data.socialSharingTextTitle? data.socialSharingTextTitle: data.detail?(data.detail).replace(/<[^>]*>/g,"").replace(/\\s+/g, " ").trim():'';
               const socialShareUrl =  data.seoUrl && data.seoUrl != '' ? data.seoUrl:`${data.webapp}#${data.hash}`;
               const socialShareDescription =  data.shareEnabled && data.socialSharingTextDescription?data.socialSharingTextDescription:data.description?(data.description).replace(/<[^>]*>/g,"").replace(/\\s+/g, " ").trim():'';
               const socialShareMedia =  data.shareEnabled && data.socialSharingBackgroundImageUrl?data.socialSharingBackgroundImageUrl:(data.logoBg && data.logoBg.file)?(data.logoBg.file):'';

               return <div className='social-share-multi'>
                        <IoMdArrowDropleft onClick={()=>this.handleChangeShare('previous',socialShareRef)} style={{cursor:'pointer'}} size={50} color="#fff" fill={data.buttonColor}/>
                        <div className='social-share-wrapper' ref={socialShareRef}>
                            <div className='wrapper' > <FacebookShareButton
                              url={socialShareUrl}
                              quote={socialShareTitle}
                              size={32} round={true} >
                                <FacebookIcon size={32} round={true} />
                                </FacebookShareButton>
                                <TwitterShareButton
                                url={socialShareUrl}
                                title={socialShareTitle}
                                >
                                  <TwitterIcon size={32} round={true}/>
                                </TwitterShareButton>
                            </div>
                            <div className='wrapper' >
                            <CustomShare className="messenger" variant="facebook-messenger" config={{url:socialShareUrl}}>
                                <FacebookMessengerIcon size={32} round={true} />
                            </CustomShare>
                                <WhatsappShareButton
                              url={socialShareUrl}
                              title={socialShareTitle}
                              >
                                <WhatsappIcon size={32} round={true} />
                                </WhatsappShareButton>
                            </div>
                            <div className='wrapper' >
                              <CustomShare className="sms" variant="sms" config={{text: socialShareTitle+' ',url: socialShareUrl,
                            }}><FaSms  size={20}  style={{color:'#3B5997', fill:'#ffffff'}}  /></CustomShare>
                            <EmailShareButton
                              url={socialShareUrl}
                              subject={socialShareTitle}
                              body={socialShareDescription} >
                                <EmailIcon size={34} round={true}/>
                                </EmailShareButton>
                            </div>
                            <div className='wrapper' >
                              {/* <LinkedinShareButton
                              url={socialShareUrl}
                              title={socialShareTitle}
                              summary={socialShareDescription}
                              source={socialShareUrl}
                              >
                              <LinkedinIcon size={32} round={true} />
                              </LinkedinShareButton> */}
                              <RedditShareButton
                              url={socialShareUrl}
                              title={socialShareTitle}
                              description={socialShareDescription} >
                                <RedditIcon size={32} round={true} />
                                </RedditShareButton>
                                <CustomShare className="skype" config={{url: socialShareUrl,
                            text:socialShareTitle}} variant="skype"><FaSkype  size={20} style={{color:'#3B5997', fill:'#ffffff'}}/></CustomShare>
                            </div>
                            <div className='wrapper' >
                              <PinterestShareButton
                              url={socialShareUrl}
                              title={socialShareTitle}
                              description={socialShareDescription}
                              media={socialShareMedia}
                              >
                                <PinterestIcon size={32} round={true} />
                                </PinterestShareButton>
                                <CustomShare className="wordpress" variant="wordpress" config={{url: socialShareUrl,
                            text: socialShareTitle,
                            media:socialShareMedia }}><FaWordpress  size={20}  style={{color:'#3B5997', fill:'#ffffff'}}  /></CustomShare>
                            </div>
                            <div className='wrapper' >
                              <CustomShare className="flipboard" variant="flipboard" config={{url: socialShareUrl,
                            text: socialShareTitle}}><FaFlipboard  size={20}  style={{color:'#3B5997', fill:'#ffffff'}}/></CustomShare>
                              <TumblrShareButton
                              url={socialShareUrl}
                              title={socialShareTitle}
                              caption={socialShareDescription} >
                                <TumblrIcon size={32} round={true} />
                                </TumblrShareButton>
                            </div>
                            <div className='wrapper' >
                                <CustomShare className="buffer" variant="buffer" config={{url:socialShareUrl,
                            text: socialShareTitle,
                            media:socialShareMedia}}><FaBuffer size={18}  style={{color:'#3B5997', fill:'#ffffff'}}  /></CustomShare>
                            <PocketShareButton
                              url={socialShareUrl}
                              title={socialShareTitle}
                              description={socialShareDescription} >
                                <PocketIcon size={32} round={true} />
                              </PocketShareButton>
                            </div>
                            {/* <div className='wrapper' >

                            </div> */}
                          </div>
                          <IoMdArrowDropright onClick={()=>this.handleChangeShare('next',socialShareRef)} style={{cursor:'pointer'}} size={50} color="#fff" fill={data.buttonColor}/>
                        </div>
            }



            let voteSubmitError = submitFor === currentRound.id && submitError ? <div
                className='vote-submit-error'>
                {submitErrorMessage}
            </div> : null;

            if (this.props.competition.submitting) {
                // voteSubmitError = (<div
                //     className='vote-submit-info'>
                //     <FontAwesomeIcon className='benchvote-spin' icon={faSpinner} spin/>
                //     Submitting vote...
                // </div>);
                submitButtonText = 'Submitting';
            } else if (this.props.competition.submitted && this.props.competition.submittedIdInterval === currentRound.id && this.props.auth.loggedIn) {
                // voteSubmitError = (<div
                //     className='vote-submit-success'>
                //     Thanks, your entry has been saved
                // </div>);
                submitButtonText = 'Sent';
            }

            let noBorderRadius = (data.defaultShape == 2);

            this.defaultShape = data && data.defaultShape;

            if (this.defaultShape && this.shapesList[this.defaultShape]) {
              this.classRadius = this.shapesList[this.defaultShape];
            }

            const willingDiv = this.state.willingToPlay ? (
                <Modal show={true} onHide={this.handleCloseModal} dialogClassName={(noBorderRadius ? 'no-border-radius' : '')}>
                    <Modal.Body>
                        <div className={'logging-in'}>
                        <Trans i18nKey="log_to_vote" />
                            <div className='button-modal' onClick={this.handleCloseModal}>
                            <Trans i18nKey="accept" /><em>></em>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            ) : null;

            const intervalChangeDiv = this.state.showIntervalChangeWarning ? (
                <Modal show={true} onHide={this.intervalModalAwayClick} dialogClassName={(noBorderRadius ? 'no-border-radius' : '') + ' ' + this.classRadius}>
                    <Modal.Body>
                        <div className={'logging-in login-options white-bg'}>
                            Please submit your pick before changing the interval
                            <div className='button btn-save-interval margin red_btn action-btn-set' onClick={this.proceedSavingInterval}>
                                Save Interval
                            </div>
                            <div className='btn-proceed' onClick={this.proceedWithoutSavingInterval}>
                                Proceed without saving
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            ) : null;

// console.log('this.props', this.props);
            voteCont = (<div
                style={{color: data ? data.primaryColor : ''}}
                className='vote-cont'>
                <h1 style={{color: data ? data.primaryColor : ''}} dangerouslySetInnerHTML={{__html: data.detail}} className={'mini-site-title'}/>
                <p style={{color: data ? data.primaryColor : ''}} dangerouslySetInnerHTML={{__html: data.description}} className={'mini-site-description'}/>
                {inviteToVote}
                {voteSubmitError}
                {/* {shareVote} */}

                {data && data.shareEnabled? socialShareTemplate(this.socialShareRef1):null}
                {data && data.type !== 'leaderboard' ?
                    (data.type === 'tipping' ?

                    <TippingSelector onSelectionChange={this.changeSelection}
                        onTriggerRegisterLogin={this.props.onTriggerAppRegisterLogin}/> :

                    <VideoSelector onSelectionChange={this.changeSelection} onSelectionChangeLoad={this.changeSelectionLoad}
                        onTriggerRegisterLogin={this.props.onTriggerAppRegisterLogin}/>) :

                    <Field loggedIn={this.props.auth.loggedIn} onSelectionChange={this.changeSelection}
                        onSelectionChangeLoad={this.changeSelectionLoad}
                        onTriggerRegisterLogin={this.props.onTriggerAppRegisterLogin}/>
                }
                {voteSubmitError}
                {willingDiv}
                {intervalChangeDiv}
                {/* {shareVote} */}
                {data && data.shareEnabled? socialShareTemplate(this.socialShareRef2):null}

                {/* dynamic render of voted players */}
                {dynamicSubmitting ? (<div className={"text-nowrap loading-block " + ((competition.submittedIdInterval === currentRound.id && competition.submitted)
                    ? '' : 'dynamic-render-hide')}><Trans i18nKey="loading" /></div>)
                    : dynamicRenderUrl && dynamicRenderUrl != ''
                        ? (<div className={"dynamic-render " + ((competition.submittedIdInterval === currentRound.id && competition.submitted) ? '' : 'dynamic-render-hide')}>
                            <img src={dynamicRenderUrl} className={'dynamic-render-image'} alt={''}/>
                            <a target="_blank" className={"dynamic-render-button"}
                                style={{
                                    backgroundColor: data ? data.buttonColor : '',
                                    color: data ? data.primaryColor : ''
                                }}
                                href={dynamicRenderUrl} download="share-image.jpg">
                                    <Trans i18nKey="download_image" />
                            </a>
                        </div>)
                        : null}

            </div>)
        }

        return (<div className={"parent-vote-cont " + (noBorderRadius ? 'no-border-radius' : '')}>
            {this.props.showOnlyLeaderboard ? voteContOnlyLeaderboard : voteCont}
            {/*{data && data.type !== 'leaderboard' ?*/}
            {/*<VideoSelector onSelectionChange={this.changeSelection}/> :*/}
            {/*<Field loggedIn={this.props.auth.loggedIn}*/}
            {/*// style={{display: (this.props.auth.loggedIn ? 'block' : 'none')}}*/}
            {/*onSelectionChange={this.changeSelection}/>*/}
            {/*}*/}
            {!this.props.showOnlyLeaderboard && this.state.loggedIn && currentRound && currentRound.voteOpen ?
                (<div ref={this.submitBtnRef} id='vote-submit-btn' className={"vote-btn bottom-btn " + (submitButtonText === "Sent" ? 'bg-green' : '')}
                      style={{
                        backgroundColor: data ? data.buttonColor : '',
                        color: data ? data.secondaryColor : ''
                      }}
                      onClick={() => this.handleSubmit(currentRound.id)}>
                          {t(submitButtonText.toLowerCase())}
                      </div>) : null}
        </div>);
    }
}

//-------------------------------------------------------------------------
//-------------------- Mapping store to App's props ----------------------
//-------------------------------------------------------------------------

const mapStateToProps = (state, ownProps) => {

    const things = state.default;
    return {
        ...ownProps,
        competition: things.competition,
        comp: things.competition.data,
        auth: things.auth,
        locale: things.locale
    }
}

const
    mapDispatchToProps = dispatch => {
        return {
            dispatch
        }
    }

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Voting));
